import React from 'react';
import {getLocalizedStr} from "../../middlewares/i18n/utils";
import {Modal} from "antd";
import EnhancedTree from "../enhanced-tree";
import {DataLanguageConsumer} from "../../contexts/DataLanguage";
import {TREE_NODE_KEY_PREFIX} from "../tree-filter/utils";
import {getNodes, getNodesAtDepth} from "../../utils/tree";
import _ from "lodash";
import {BUTTON_CHECK_ALL_CHILDS} from "../../styles/buttons";
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {SPAN_HALF} from "../../styles/constants";

const mapStateToProps = state => ({
  dataLanguages: state.config.dataManagement.dataLanguages,
});

const TREE_NODE_KEY_ALL = TREE_NODE_KEY_PREFIX + 'ALL';
const TREE_NODE_KEY_OF_LEVEL_PREFIX = TREE_NODE_KEY_PREFIX + 'OF_LEVEL_';

const CheckableItemsTree = ({
                              t,
                              itemTree,
                              itemTreeMaxDepth,
                              childrenKey,
                              dataLanguages,
                              rightActions,
                              selectedItems,
                              onSelectedItemsChange,
                              getIsDisabledNode
                            }) => {

    const levelNodesKeys =
      itemTreeMaxDepth
        ? [...Array(itemTreeMaxDepth)]
          .map((_, index) => TREE_NODE_KEY_OF_LEVEL_PREFIX + index)
        : [];

    return (
      <DataLanguageConsumer>
        {lang => {
          return (
            <EnhancedTree
              searchBarSpan={SPAN_HALF}
              treePrefix={
                (itemTree && itemTree.length > 0)
                  ? [
                    (() => {
                      const obj = {
                        id: TREE_NODE_KEY_OF_LEVEL_PREFIX + 0,
                        name: {
                          en: t('components.checkableItemsTree.levelNode', {level: 0})
                        },
                        level: 0,
                      };
                      if (itemTreeMaxDepth !== null) {
                        [...Array(itemTreeMaxDepth - 1)]
                          .forEach(() => {
                            let pointer = obj;
                            let counter = 0;
                            while (pointer[childrenKey]) {
                              pointer = pointer[childrenKey][0];
                              counter++;
                            }
                            pointer[childrenKey] = [
                              {
                                id: TREE_NODE_KEY_OF_LEVEL_PREFIX + Number(counter + 1),
                                name: {
                                  en: t('components.checkableItemsTree.levelNode', {level: counter + 1})
                                },
                                level: counter + 1
                              }
                            ];
                          });
                      }
                      return obj;
                    })()
                  ]
                  : null
              }
              tree={itemTree}
              getNodeKey={({id}) => id}
              childrenKey={childrenKey}
              hiddenIdKeys={[
                TREE_NODE_KEY_ALL,
                ...levelNodesKeys
              ]}
              idKey="id"
              nameKey="name"
              catIdKey="id"
              catNameKey="name"
              icon="file-text"
              isRootIconLikeChildrenIcon
              isEmptyCategoryIconLikeLeafIcon
              getFilter={
                searchText =>
                  ({id, name}) => {
                    const search = searchText.toLowerCase();
                    return (id && id.toLowerCase()
                        .indexOf(search) >= 0) ||
                      getLocalizedStr(name, lang, dataLanguages)
                        .toLowerCase()
                        .indexOf(search) >= 0;
                  }
              }
              rightActions={rightActions}
              onShowMoreForbidden={
                () => Modal.warning({
                  title: t('components.checkableItemsTree.modals.maxTreeSizeReached.title'),
                  content: t('components.checkableItemsTree.modals.maxTreeSizeReached.content')
                })
              }
              checkable
              checkStrictly
              checkedKeys={{
                checked: selectedItems
              }}
              onCheck={({checked}, {node, checked: isChecked}) => {

                let newChecked = [];

                if (node.props.eventKey === TREE_NODE_KEY_ALL) {
                  if (isChecked) {
                    newChecked = [
                      TREE_NODE_KEY_ALL,
                      ...levelNodesKeys,
                      ...getNodes(itemTree, childrenKey, () => true)
                        .map(({id}) => id)
                    ];
                  } else {
                    newChecked = [];
                  }
                } else if (levelNodesKeys.includes(node.props.eventKey)) {
                  const level = Number(node.props.eventKey.replace(TREE_NODE_KEY_OF_LEVEL_PREFIX, ""));

                  const keysAtDepth =
                    getNodesAtDepth(itemTree, childrenKey, level + 1).map(({id}) => id);

                  if (isChecked) {
                    newChecked = _.uniq([
                      TREE_NODE_KEY_OF_LEVEL_PREFIX + level,
                      ...checked,
                      ...keysAtDepth
                    ]);
                  } else {
                    newChecked = checked.filter(key => !keysAtDepth.includes(key));
                  }
                } else {
                  newChecked = checked.filter(key => !key.startsWith(TREE_NODE_KEY_PREFIX));
                }

                onSelectedItemsChange(newChecked);

              }}
              getNodeIsCheckable={getIsDisabledNode ? node => !getIsDisabledNode(node) : null}
              nodeActions={[
                node =>
                  node[childrenKey] && node[childrenKey].length > 0 && !node.id.startsWith(TREE_NODE_KEY_PREFIX)
                    ? ({
                      ...BUTTON_CHECK_ALL_CHILDS,
                      title: t("components.checkableItemsTree.checkUncheckAllChilds.title"),
                      onClick: () => {
                        const childIds =
                          node[childrenKey]
                            .filter(node => getIsDisabledNode ? !getIsDisabledNode(node) : true)
                            .map(({id}) => id);

                        const mergedIds = _.uniq(childIds.concat(selectedItems));

                        let newSelectedItems =
                          mergedIds.length > selectedItems.length
                            ? mergedIds
                            : selectedItems.filter(id => !childIds.includes(id));

                        onSelectedItemsChange(newSelectedItems);
                      }
                    })
                    : null
              ]}
            />
          );
        }}
      </DataLanguageConsumer>
    );
  }
;

export default compose(
  translate(),
  connect(mapStateToProps)
)(CheckableItemsTree);